import { useState } from "react";
import { CustomerPicker } from "../../../components/common/CustomerPicker";
import { UserPlus } from "lucide-react";
import { toast } from "sonner";
import { useI18n } from "../../../i18n";
import { api } from "../../../lib/api";

const inputCls = "mt-1 h-11 w-full rounded-xl border border-slate-200 bg-white px-3 text-sm text-navy outline-none focus:border-brand focus:ring-4 focus:ring-brand/15";

export const InviteForm = ({ customers, onInvited }) => {
  const { t } = useI18n();
  const [form, setForm] = useState({ email: "", name: "", customer_code: "", role: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/admin/users/invite", { ...form, role: form.role || undefined });
      toast.success(t("users.invited"));
      setForm({ email: "", name: "", customer_code: form.customer_code, role: "" });
      onInvited(data.invite_link);
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : t("common.error"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="grid gap-3 rounded-2xl bg-white p-5 shadow-sm sm:grid-cols-2 lg:grid-cols-5 lg:items-end" data-testid="invite-form">
      <label className="block"><span className="text-xs font-medium text-slate-500">{t("login.email")}</span><input type="email" required value={form.email} onChange={set("email")} className={inputCls} data-testid="invite-email" /></label>
      <label className="block"><span className="text-xs font-medium text-slate-500">{t("users.name")}</span><input required value={form.name} onChange={set("name")} className={inputCls} data-testid="invite-name" /></label>
      <label className="block"><span className="text-xs font-medium text-slate-500">{t("users.customer")}</span>
        <CustomerPicker customers={customers} value={form.customer_code} onChange={(code) => setForm((f) => ({ ...f, customer_code: code }))} required testId="invite-customer" />
      </label>
      <label className="block"><span className="text-xs font-medium text-slate-500">{t("users.role")}</span>
        <select value={form.role} onChange={set("role")} className={inputCls} data-testid="invite-role">
          <option value="">{t("users.roleAuto")}</option>
          <option value="approver">{t("users.roles.approver")}</option>
          <option value="buyer">{t("users.roles.buyer")}</option>
        </select>
      </label>
      <button type="submit" disabled={busy} data-testid="invite-submit" className="flex h-11 items-center justify-center gap-2 rounded-full bg-brand px-5 text-sm font-semibold text-white hover:bg-[#25a065] disabled:opacity-50">
        <UserPlus className="h-4 w-4" /> {t("users.invite")}
      </button>
    </form>
  );
};
